// STATUS_CONFIG condiviso, in origine nel modale PartnerDetails.tsx ritirato il 10/08/2026
// (vedi PartnerDetailsPage.tsx / PartnerInfoPanel.tsx, pagina dedicata Fase 1 Note & Attività).
export const STATUS_CONFIG = {
  'active': { label: 'Attivo', color: 'green', bgClass: 'bg-green-100 text-green-800' },
  'inactive': { label: 'Inattivo', color: 'gray', bgClass: 'bg-gray-100 text-gray-800' },
  'suspended': { label: 'Sospeso', color: 'red', bgClass: 'bg-red-100 text-red-800' },
  'pending_approval': { label: 'In Attesa', color: 'yellow', bgClass: 'bg-yellow-100 text-yellow-800' }
} as const;

export type PartnerStatusKey = keyof typeof STATUS_CONFIG;

// Etichette dei vecchi codici tipo partner (i tipi nuovi sono gia' nomi leggibili,
// configurati in Impostazioni). Stesse label dei filtri di PartnersPage.
export const PARTNER_TYPE_LABELS: Record<string, string> = {
  service_provider: 'Fornitore di Servizi',
  consultant: 'Consulente',
  supplier: 'Fornitore',
  agency: 'Agenzia',
  freelancer: 'Freelancer',
};

export function partnerTypeLabel(type?: string | null): string | null {
  if (!type) return null;
  return PARTNER_TYPE_LABELS[type] || type;
}
